import { animate, animation, AnimationTriggerMetadata, state, style, transition, trigger, useAnimation } from '@angular/animations';

const animationBody = [
    // Note: The `enter` animation transitions to `transform: none`, because for some reason
    // specifying the transform explicitly, causes IE both to blur the modal content and
    // decimate the animation performance. Leaving it as `none` solves both issues.
    state('void, exit', style({ opacity: 0, transform: 'scale(0.7)' })),
    state('enter', style({ transform: 'none' })),
    transition('* => enter', animate('150ms cubic-bezier(0, 0, 0.2, 1)', style({ transform: 'none', opacity: 1 }))),
    transition('* => void, * => exit', animate('75ms cubic-bezier(0.4, 0.0, 0.2, 1)', style({ opacity: 0 })))
];

const animationBodyTop = [
    state('void, exit', style({ opacity: 0, transform: 'translateY(-100%)' })),
    state('enter', style({ transform: 'translateY(0%)' })),
    transition('void => enter', animate('375ms 150ms cubic-bezier(0.0, 0.0, 0.2, 1)', style({ transform: 'translateY(0%)', opacity: 1 }))),
    transition(
        'enter => void, enter => exit',
        animate('375ms cubic-bezier(0.4, 0.0, 1, 1)', style({ opacity: 0, transform: 'translateY(-100%)' }))
    )
];

const animationBodyRight = [
    state('void, exit', style({ opacity: 0, transform: 'translateX(100%)' })),
    state('enter', style({ transform: 'translateX(0%)' })),
    transition('void => enter', animate('375ms 150ms cubic-bezier(0.0, 0.0, 0.2, 1)', style({ transform: 'translateX(0%)', opacity: 1 }))),
    transition(
        'enter => void, enter => exit',
        animate('375ms cubic-bezier(0.4, 0.0, 1, 1)', style({ opacity: 0, transform: 'translateX(100%)' }))
    )
];

const animationBodyBottom = [
    state('void, exit', style({ opacity: 0, transform: 'translateY(100%)' })),
    state('enter', style({ transform: 'translateY(0%)' })),
    transition('void => enter', animate('375ms 150ms cubic-bezier(0.0, 0.0, 0.2, 1)', style({ transform: 'translateY(0%)', opacity: 1 }))),
    transition(
        'enter => void, enter => exit',
        animate('375ms cubic-bezier(0.4, 0.0, 1, 1)', style({ opacity: 0, transform: 'translateY(100%)' }))
    )
];

const showAnimation = animation([style({ transform: '{{transform}}', opacity: 0 }), animate('{{transition}}')]);

const hideAnimation = animation([animate('{{transition}}', style({ transform: '{{transform}}', opacity: 0 }))]);

const animationBodyCustom = [
    transition('void => enter', [useAnimation(showAnimation)]),
    transition('enter => void, enter => exit', [useAnimation(hideAnimation)])
];

/**
 * Animations used by modal.
 */
export const modalAnimations: {
    readonly modalContainer: AnimationTriggerMetadata;
    readonly modalTopContainer: AnimationTriggerMetadata;
    readonly modalRightContainer: AnimationTriggerMetadata;
    readonly modalBottomContainer: AnimationTriggerMetadata;
    readonly modalCustomContainer: AnimationTriggerMetadata;
} = {
    /** Animation that is applied on the modal container by defalt. */
    modalContainer: trigger('modalContainer', animationBody),
    modalTopContainer: trigger('modalTopContainer', animationBodyTop),
    modalRightContainer: trigger('modalRightContainer', animationBodyRight),
    modalBottomContainer: trigger('modalBottomContainer', animationBodyBottom),
    modalCustomContainer: trigger('modalCustomContainer', animationBodyCustom)
};
